import classNames from 'classnames'
import { useCallback } from 'react'
import { Tabs } from '@material-ui/core'

import { MainScreenContentType } from '@tabeeb/enums'
import VideoPlayerControls from '@tabeeb/modules/player/containers/ShowPlayerControlsContainer'
import useStyles from '../PlayerToolbar/styles'
import Pagination from '../Pagination'
import ToolbarGate from '../ToolbarGate'
import CompassButton from '../CompassButton'
import DownloadButton from '../DownloadButton'
import HideAnnotationsButton from '../HideAnnotationsButton'
import PaletteButton from '../PaletteButton'
import PointCloudControls from '../PointCloudControls'
import ModelButton from '../ModelButton'
import ViewerBackgroundButton from '../ViewerBackgroundButton'
import { FieldOfViewButtonContainer } from '../FieldOfViewButton'
import { PointCloudSettingsButtonContainer } from '../PointCloudSettingsButton'
import { PointCloudCameraNavigationButtonContainer } from '../PointCloudCameraNavigationButton'
import PointCloudMeasurementsButton from '../PointCloudMeasurementsButton'
import ZoomButtons from '../ZoomButtons'
import PlaybackButton from '../PlaybackButton'
import PlayerTimer from '../PlayerTimer'
import VolumeButton from '../VolumeButton'
import FullScreenButton from '../FullScreenButton'
import PointCloudDocumentationButton from '../PointCloudDocumentationButton'

const ReadonlyPlayerToolbar = () => {
  const classes = useStyles()

  const LeftSidePanel = useCallback(
    () => (
      <div className={classNames(classes.panel, classes.side, classes.left)}>
        <ToolbarGate contentType={MainScreenContentType.Gallery}>
          <Pagination />
        </ToolbarGate>
      </div>
    ),
    [classes.left, classes.panel, classes.side]
  )

  const CenterPanel = useCallback(
    () => (
      <div className={classNames(classes.panel, classes.center)}>
        <ToolbarGate contentType={MainScreenContentType.Gallery}>
          <CompassButton />
          <DownloadButton />
          <HideAnnotationsButton />
          <PointCloudControls>
            <ModelButton />
            <ViewerBackgroundButton />
            <FieldOfViewButtonContainer />
            <PointCloudSettingsButtonContainer />
            <PointCloudCameraNavigationButtonContainer />
            <PointCloudMeasurementsButton />
            <PaletteButton />
          </PointCloudControls>

          <div className={classes.centerPlaceholder} />
        </ToolbarGate>
      </div>
    ),
    [classes.center, classes.centerPlaceholder, classes.panel]
  )

  const RightSidePanel = useCallback(
    () => (
      <div className={classNames(classes.panel, classes.side, classes.right)}>
        <ToolbarGate contentType={MainScreenContentType.Gallery}>
          <ZoomButtons />
          <VideoPlayerControls>
            <PlaybackButton />
            <PlayerTimer />
            <VolumeButton />
            <FullScreenButton />
          </VideoPlayerControls>
          <PointCloudControls>
            <PointCloudDocumentationButton />
          </PointCloudControls>
        </ToolbarGate>
      </div>
    ),
    [classes.panel, classes.right, classes.side]
  )

  return (
    <section className={classes.container}>
      <Tabs
        value={false}
        className={classes.toolbar}
        indicatorColor='primary'
        textColor='primary'
        variant='scrollable'
        scrollButtons='auto'
      >
        <LeftSidePanel />
        <CenterPanel />
        <RightSidePanel />
      </Tabs>
    </section>
  )
}

export default ReadonlyPlayerToolbar
